import * as React from 'react';
import DataGrid from '../components/DataGrid';
import GetColumnDefs from '../components/ColumnDefs';
import { Button } from '@progress/kendo-react-buttons';
import { GetPermissions } from '../components/Options';
import { useNavigate } from "react-router-dom";
import Notifications from '../components/Notifications';
import configData from "../config.json";
import { GetSession, GetToken } from '../components/Session';
import { DropDownList } from "@progress/kendo-react-dropdowns";

const BusinessData = () => {
    const [columns, setColumns] = React.useState(null);
    const [errorMessage, setErrorMessage] = React.useState("");
    const [permissions, setPermissions] = React.useState(null);
    const [sites, setSites] = React.useState([]);
    const [site, setSite] = React.useState();
    const statii = ["All", "Active", "Inactive"];
    const [status, setStatus] = React.useState("Active");
    const navigate = useNavigate();
    const [lookupParams, setLookupParams] = React.useState("");
    const options = React.useRef();
    const [forceUpdate, setForceUpdate] = React.useState("");
    const [layout, setLayout] = React.useState([
        { "field": "searchSite", "label": "Site", "isVisible": true, "type": "list" },
    ]);
    let bds = localStorage.getItem("BDSearch");
    if (localStorage.getItem("userid") === null) navigate("/logout");

    if (permissions && !permissions.EditAppSettings) navigate("/error401");
    React.useEffect(() => {
        GetColumnDefs("BusinessData", setColumns);
        GetPermissions(["EditAppSettings", "NewAppSettings"], setPermissions);
        let baseUrl = configData.SERVER_URL + "apiv7/options";
        const init = {
            method: "GET",
            accept: "application/json",
            headers: { "Authorization": "Bearer " + GetToken() },
        };
        baseUrl = configData.SERVER_URL + "apiv7/options";
        fetch(baseUrl, init).then((response) => response.json()).then((d) => {
            options.current = d;
            setSites(CreateList(d.sites));
            let p = localStorage.getItem("BDSearch");
            if (p !== undefined && p !== "" && p !== null) {
                let def = JSON.parse(p);
                let s = d.sites.find(obj => obj.id === def.Site);
                setSite(s);
                setStatus(def.Status);
            } else {
                setSite({ id: "0", name: "All" });
                setStatus("Active");
            }
            if (bds !== undefined && bds !== "" && bds !== null) {
                setTimeout(() => { UpdateSavedParams() }, 100);
            }
        });
    }, [])

    const GetField = (f, def) => {
        let r = layout.find(obj => { return obj.field === f });
        if (r === undefined) r = { "field": f, "label": def, "isVisible": true, "type": "text" };
        return r;
    }
    const siteChanged = (event) => {
        setSite(event.target.value);
        var p = {
            Site: event.target.value.id,
            Status: status
        };
        setLookupParams(encodeURI(JSON.stringify(p)));
        localStorage.setItem("BDSearch", JSON.stringify(p));
    }

    const statusChanged = (event) => {
        setStatus(event.target.value);
        var p = {
            Site: site.id,
            Status: event.target.value
        };
        setLookupParams(encodeURI(JSON.stringify(p)));
        localStorage.setItem("BDSearch", JSON.stringify(p));
    }

    const UpdateSavedParams = () => {
        if (bds === undefined) return;
        let def = JSON.parse(bds);
        let st = options.current.sites.find(obj => { return obj.id === def.Site });
        if (st === undefined) st = {id: '1', name: 'Cloud'};
        setSite(st);
        setStatus(def.Status);
        var p = {
            Site: st.id,
            Status: def.Status
        };
        setLookupParams(encodeURI(JSON.stringify(p)));
    }

    const GetSelected = (c, d) => {
        let r = [];
        if (d === undefined || d === null || d === "0") return r;
        let sp = d.split(';');
        sp.forEach(s => {
            let f = c.find(obj => { return obj.id === s });
            if (f !== undefined) r.push(f);
        });
        return r;
    }

    const CreateList = (d) => {
        var x = [{ id: "0", name: "All" }];
        d.map((v) => x.push({ id: v.id, name: v.name + " (" + v.id + ")" }));
        return x;
    };

    const BulkStatus = (rec, st) => {
        let url = configData.SERVER_URL + `apiv7/businessdata/businessdataactive?bdList=${rec}&status=${st}`;
        const init = {
            method: 'PATCH',
            accept: 'application/json',
            headers: { "Authorization": "Bearer " + GetToken() }
        }
        fetch(url, init).then(response => {
            setForceUpdate(new Date());
        });
    }


    return (
        <div>
            <Notifications errorMessage={errorMessage} />
            <div className="row" style={{ padding: "5px 10px" }}>
                {GetField("searchSite")["isVisible"] && <div className="col-md-3">
                    <label className="control-label">{GetField("searchSite")["label"]}</label>
                    <DropDownList id="Site" data={sites} value={site} textField="name" dataItemKey="id" onChange={siteChanged} />
                </div>}
                {GetField("searchStatus")["isVisible"] && <div className="col-md-3">
                    <label className="control-label">{GetField("searchStatus", "Status")["label"]}</label>
                    <DropDownList id="Status" data={statii} value={status} onChange={statusChanged} />
                </div>}
            </div>
            <div className="row">
                {columns && permissions && <DataGrid dataSource='apiv7/businessdata' columns={columns} permissions={permissions} params={lookupParams} bulkStatus={BulkStatus} update={forceUpdate} keyField="businessDataId" />}
            </div>
        </div>
    );

}

export default BusinessData;